import React from "react"
import Section from "../../../../core/layout/main/section/Section"
import { snippetClickHandler } from "../../../../../utils/contentBuilderLib"

const ContentBuilderSection = ({ contentContentBuilder, location }) => {
  // const style = {
  //   backgroundColor: color && `var(--${color?.replace("_", "-")}-color)`,
  //   backgroundImage:
  //     backgroundImage?.data && `url(${backgroundImage.data?.attributes.url})`,
  //   backgroundPosition: backgroundImage?.data && "center center",
  //   backgroundSize: backgroundImage?.data && "cover",
  // }

  // const sectionClasses = sectionClass
  //   ?.replace(/,/g, " ")
  //   .replace(/\s\s+/g, " ")
  //   .trim()
  //   .split(" ")
  //   .join(" ")



  const style = contentContentBuilder.preset?.style || {}
  const classList = contentContentBuilder.preset?.classList || []
  classList.push("contentBuilderSection")

  return (
    <Section
      style={style}
      className={classList.join(" ")}
      onClick={(e)=>{return snippetClickHandler(e, location)}}
      dangerouslySetInnerHTML={{ __html: contentContentBuilder.html }}
    ></Section>
  )
}

export const name = "ContentBuilderSection"

export const init = (componentData, pageContext, location) => {
  return (
    <ContentBuilderSection
      key={componentData.id}
      contentContentBuilder={componentData.contentContentBuilder}
      location={location}
    />
  )
}

export default ContentBuilderSection
